import { useGetChildrenAssignments } from '@repo/api/parent/useGetChildrenAssignments';
import { useGetMyChildren } from '@repo/api/parent/useGetMyChildren';

import { ChildSectionList } from '@/components/features/parent/ChildSectionList';
import ParentPageHeader from '@/components/features/parent/layout/ParentPageHeader';
import { ParentAssignmentCard } from '@/components/features/parent/ParentAssignmentCard';
import { ParentAssignmentDialog } from '@/components/features/parent/ParentAssignmentDialog';
import { ParentListSection } from '@/components/features/parent/ParentListSection';
import { ParentListToolbar } from '@/components/features/parent/ParentListToolbar';
import { useParentListParams } from '@/hooks/parent';

export default function ParentAssignmentsPage() {
  const { data: children = [], isPending: isPendingChildren, isError, errorMessage } = useGetMyChildren();
  const listParams = useParentListParams();

  const { results, failed, isPending } = useGetChildrenAssignments(children, listParams.buildParamsFor, !isPendingChildren);

  return (
    <div className={'base-direction-col'}>
      <div className={'flex w-full grow flex-col gap-6'}>
        <ParentPageHeader title={'Zadania'}>
          <ParentListToolbar childUsers={children} listParams={listParams} />
        </ParentPageHeader>

        <ChildSectionList
          results={results}
          failed={failed}
          isPending={isPendingChildren || isPending}
          isError={isError}
          errorMessage={errorMessage}
          summary={(data) => `Wyników: ${data.total}`}
          defaultExpanded={'none'}
        >
          {(data, child) => (
            <ParentListSection childId={child.id} data={data} listParams={listParams} emptyMessage={'Brak zadań'}>
              {(assignments) => (
                <ul className={'flex flex-col gap-2'}>
                  {assignments.map((assignment) => (
                    <ParentAssignmentCard key={assignment.id} assignment={assignment} childId={child.id} />
                  ))}
                </ul>
              )}
            </ParentListSection>
          )}
        </ChildSectionList>
      </div>

      <ParentAssignmentDialog />
    </div>
  );
}
